import { getUserLanguageForI18n } from '@quadminds/shared/utils';
import { useEffect } from 'react';
import i18n from '../config/i18n';

/**
 * Custom hook to manage user language preferences using i18n.
 * It normalizes the user locale and updates the i18n language accordingly.
 *
 * @param userLocale - The user's preferred locale (e.g., 'en-US', 'es-ES').
 * @returns An object containing the current language and a function to change the language.
 */
export const useUserLanguage = (userLocale?: string) => {
    useEffect(() => {
        const normalizedLanguage = getUserLanguageForI18n(userLocale, ['es', 'en'], 'es');
        i18n.changeLanguage(normalizedLanguage).catch(() => {
            console.error(`Failed to change language to ${normalizedLanguage}`);
        });
    }, [userLocale]);

    return {
        currentLanguage: i18n.language,
        changeLanguage: (language: string) => {
            const normalizedLanguage = getUserLanguageForI18n(language, ['es', 'en'], 'es');
            return i18n.changeLanguage(normalizedLanguage);
        },
    };
};
